<template>
    <el-dialog
        :title="isEdit ? 'Chỉnh sửa video' : 'Thêm mới video'"
        :visible.sync="dialogVisible"
        width="700px"
        :before-close="handleClose"
    >
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <el-form @submit.native.prevent="handleSubmit(submit)" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <ValidationProvider name="Tên video" rules="required|max:255" v-slot="{ errors }">
                            <el-form-item label="Tên video" required>
                                <el-input v-model="form.name" placeholder="Nhập tên video" />
                                <span class="text-danger">{{ errors[0] }}</span>
                            </el-form-item>
                        </ValidationProvider>
                    </el-col>
                    <el-col :span="12">
                        <ValidationProvider name="Trung tâm áp dụng" rules="required" v-slot="{ errors }">
                            <el-form-item label="Trung tâm áp dụng" required>
                                <el-select v-model="form.center_ids" multiple filterable placeholder="Chọn trung tâm áp dụng" style="width: 100%">
                                    <el-option v-for="item in centers" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </el-form-item>
                        </ValidationProvider>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="18">
                        <ValidationProvider name="Link video" rules="required" v-slot="{ errors }">
                            <el-form-item label="Link video" required>
                                <el-input type="textarea" :rows="3" v-model="form.url" placeholder="Dán liên kết link web tại đây" />
                                <span class="text-danger">{{ errors[0] }}</span>
                            </el-form-item>
                        </ValidationProvider>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="Kích hoạt">
                            <el-switch v-model="form.status" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <!-- Hidden duration (total seconds) must be the first input: vee-validate only validates the first detected field. -->
                        <ValidationProvider
                            name="Thời lượng"
                            :rules="{ required: true, min_value: 1 }"
                            :custom-messages="{
                                required: 'Thời lượng không được bỏ trống',
                                min_value: 'Thời lượng phải lớn hơn 00:00:00'
                            }"
                            v-slot="{ errors }"
                        >
                            <el-form-item label="Thời lượng" required>
                                <input type="hidden" v-model.number="form.duration" />
                                <el-time-picker
                                    v-model="durationTime"
                                    value-format="HH:mm:ss"
                                    format="HH:mm:ss"
                                    placeholder="00:00:00"
                                    clearable
                                    style="width: 100%"
                                />
                                <span class="text-danger">{{ errors[0] }}</span>
                            </el-form-item>
                        </ValidationProvider>
                    </el-col>
                </el-row>
                <div style="text-align: right">
                    <el-button @click="handleClose">Hủy</el-button>
                    <el-button type="primary" native-type="submit" :loading="loading">
                        {{ isEdit ? "Cập nhật" : "Thêm mới" }}
                    </el-button>
                </div>
            </el-form>
        </ValidationObserver>
    </el-dialog>
</template>

<script>
import { GUARANTEE_VIDEO_STORE, GUARANTEE_VIDEO_UPDATE } from "@/core/services/store/guarantee-video/guaranteeVideo.module";

export default {
    name: "GuaranteeVideoDialog",
    props: {
        visible: { type: Boolean, default: false },
        videoData: { type: Object, default: null },
        centers: { type: Array, default: () => [] },
        scheduleLearningId: { type: [Number, String], required: true },
        lesson: { type: [Number, String], required: true },
        courseId: { type: [Number, String], default: null },
    },
    data() {
        return { loading: false, form: this.getDefaultForm() };
    },
    computed: {
        dialogVisible: {
            get() { return this.visible; },
            set(val) { this.$emit("update:visible", val); }
        },
        isEdit() { return !!(this.videoData && this.videoData.id); },
        durationTime: {
            get() {
                if (this.form.duration === null || this.form.duration === undefined) return null;
                const total = Math.max(0, Number(this.form.duration) || 0);
                const h = Math.floor(total / 3600);
                const m = Math.floor((total % 3600) / 60);
                const s = total % 60;
                return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":");
            },
            set(val) {
                if (!val) {
                    this.form.duration = null;
                    return;
                }
                const [h, m, s] = String(val).split(":").map((n) => Number(n) || 0);
                this.form.duration = h * 3600 + m * 60 + s;
            },
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.form = this.videoData ? this.mapVideoToForm(this.videoData) : this.getDefaultForm();
                this.$nextTick(() => { if (this.$refs.form) this.$refs.form.reset(); });
            }
        }
    },
    methods: {
        getDefaultForm() { return { name: "", url: "", status: true, center_ids: [], duration: null }; },
        mapVideoToForm(v) {
            return {
                name: v.name || "",
                url: v.url || "",
                status: !!v.status,
                center_ids: Array.isArray(v.centerIds) ? v.centerIds : [],
                duration: v.duration === null || v.duration === undefined ? null : Number(v.duration),
            };
        },
        handleClose() { this.dialogVisible = false; },
        async submit() {
            this.loading = true;
            const payload = {
                name: this.form.name,
                url: this.form.url,
                status: this.form.status ? 1 : 0,
                center_ids: this.form.center_ids,
                duration: Number(this.form.duration) || 0,
                lesson: Number(this.lesson),
                learning_schedule_id: Number(this.scheduleLearningId),
            };
            if (this.courseId) payload.course_id = Number(this.courseId);
            try {
                if (this.isEdit) {
                    await this.$store.dispatch(GUARANTEE_VIDEO_UPDATE, { id: this.videoData.id, payload });
                    this.$message.success("Cập nhật video thành công");
                } else {
                    await this.$store.dispatch(GUARANTEE_VIDEO_STORE, payload);
                    this.$message.success("Thêm video thành công");
                }
                this.$emit("success");
                this.dialogVisible = false;
            } catch (e) {
                const msg = e?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại";
                this.$message.error(msg);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
